<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted } from "vue";
import { useStore } from "vuex";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { themeMode } from "@/core/helpers/config";
import { initializeComponents } from "@/core/plugins/keenthemes";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();

    onMounted(() => {
      /**
       * Overrides the layout config using saved data from localStorage
       * remove this to use static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      /**
       *  Sets a mode from configuration
       */
      store.dispatch(Actions.SET_THEME_MODE_ACTION, themeMode.value);

      nextTick(() => {
        initializeComponents();

        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      });
    });
  },
});
</script>

<style lang="scss">
@import "_/bootstrap-icons/font/bootstrap-icons.css";
@import "_/apexcharts/dist/apexcharts.css";
@import "_/quill/dist/quill.snow.css";
@import "_/animate.css";
@import "_/sweetalert2/dist/sweetalert2.css";
@import "_/nouislider/dist/nouislider.css";
@import "_/@fortawesome/fontawesome-free/css/all.min.css";
@import "_/socicon/css/socicon.css";
@import "_/line-awesome/dist/line-awesome/css/line-awesome.css";
@import "_/dropzone/dist/dropzone.css";
@import "_/@vueform/multiselect/themes/default.css";
@import "_/prism-themes/themes/prism-shades-of-purple.css";
@import "_/element-plus/dist/index.css";
@import '_/trickling/lib/style.css';
@import '_/datatables.net-bs5/css/dataTables.bootstrap5.min.css';

// Main demo style scss
@import "assets/sass/element-ui.dark";
@import "assets/sass/plugins";
@import "assets/sass/style";

//RTL version styles
//@import "assets/css/style.rtl.css";

#app {
  display: contents;
}
</style>
